import {
  getAllParkingBayFailure,
  getAllParkingBaySuccess,
  addNewParkingBayFailure,
  addNewParkingBaySuccess,
  editParkingBayFailure,
  editParkingBaySuccess,
  deleteParkingBaySuccess,
  deleteParkingBayFailure
} from "../constants/ParkingBay";

const initialState = {
  isProcessing: false,
  isError: false,
  addParkingBayError: false,
  editParkingBayError: false,
  deleteParkingBayError: false,
  data: {
    object: [],
    totalCount: 0
  }
};

function handleReducer(state = initialState, action) {
  switch (action.type) {
    case getAllParkingBayFailure:
      return { ...state, isError: true };

    case getAllParkingBaySuccess:
      return { ...state, data: action.payload };

    case addNewParkingBayFailure:
      return { ...state, addParkingBayError: true };

    case addNewParkingBaySuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: [...(state.data.object || []), action.payload],
          totalCount: (state.data.totalCount || 0) + 1
        }
      };

    case editParkingBayFailure:
      return { ...state, editParkingBayError: true };

    case editParkingBaySuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: state.data.object.map((item) =>
            item.id === action.payload.id ? { ...item, ...action.payload } : item
          )
        }
      };

    case deleteParkingBaySuccess:
      return {
        ...state,
        data: {
          ...state.data,
          object: state.data.object.filter((item) => item.parkingBayLocationId !== action.payload),
          totalCount: Math.max((state.data.totalCount || 1) - 1, 0)
        },
        deleteParkingBayError: false
      };

    case deleteParkingBayFailure:
      return { ...state, deleteParkingBayError: true };

    default:
      return state;
  }
}

export const parkingBayReducer = (state, action) => {
  return handleReducer(state, action);
};
